import { isEqual, get } from 'lodash'


export default (check, current, next) => {
  try {
    for (let c = 0; c < Object.keys(check).length; c++) {
      const listKey = Object.keys(check)[c]
      const list = check[listKey]
      for (let i = 0; i < list.length; i++) {
        const field = list[i]
        const shouldUpdate = !isEqual(
          get(current[listKey], field),
          get(next[listKey], field),
        )
        if (shouldUpdate) {
          return shouldUpdate
        }
      }
    }

    return false
  } catch (e) {
    console.error('Something went wrong comparing state and props. Updating by default')
    console.error(e)
    return true
  }
}
